import { RecordScreen } from "@/lib/Components/Screens/RecordScreen/RecordScreen";
import {
  BanknotesIcon,
  BuildingOffice2Icon,
  DocumentTextIcon,
} from "@heroicons/react/24/outline";
import { DollarSignIcon, FileSpreadsheetIcon } from "lucide-react";
import { useContactRecord } from "@/app/Contacts/Hooks/useContactRecord";
import { ContactType } from "@/gql/graphql";
import { Badge } from "@/components/catalyst/badge";
import { contactTypeColorMap } from "@/app/Contacts/Utils/contactTypeColorMap";
import { useTranslations } from "use-intl";
import { Link } from "@/components/catalyst/link";

export function ContactRecordScreen() {
  const contact = useContactRecord();
  const t = useTranslations("contact");
  const parentContact = contact.parentContact;
  return (
    <RecordScreen
      tabParams={{ id: contact.id }}
      title={contact.name ?? "--"}
      badges={
        <>
          <Badge color={contactTypeColorMap[contact.type]}>
            {t(`type.${contact.type}`)}
          </Badge>

          {contact.type === ContactType.Entity && parentContact ? (
            <Badge color="zinc">
              Entity of:{" "}
              <Link
                className="underline"
                from="/$tenant/$orgId/supplier/{-$supplierId}"
                to="/$tenant/$orgId/supplier/{-$supplierId}/contacts/$id"
                params={(prev) => ({
                  ...prev,
                  id: parentContact.id,
                })}
              >
                {parentContact.name}
              </Link>
            </Badge>
          ) : null}
        </>
      }
      tabs={[
        {
          name: "Details",
          to: "/$tenant/$orgId/supplier/{-$supplierId}/contacts/$id",
          Icon: DocumentTextIcon,
        },
        {
          name: "Entities",
          to: "/$tenant/$orgId/supplier/{-$supplierId}/contacts/$id/entities",
          Icon: BuildingOffice2Icon,
          isHidden: contact?.type !== ContactType.Organisation,
        },
        {
          name: "Invoices",
          to: "/$tenant/$orgId/supplier/{-$supplierId}/contacts/$id/invoices",
          Icon: DollarSignIcon,
        },
        {
          name: "Credits",
          to: "/$tenant/$orgId/supplier/{-$supplierId}/contacts/$id/credits",
          Icon: BanknotesIcon,
        },
        {
          name: "Statements",
          to: "/$tenant/$orgId/supplier/{-$supplierId}/contacts/$id/statements",
          Icon: FileSpreadsheetIcon,
        },
      ]}
    />
  );
}
